exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".half-circle-spinner .circle-1{border-top-color:#00386c!important}.half-circle-spinner .circle-2{border-bottom-color:#3f96cb!important}.v-application--wrap h1.display-1,.v-application--wrap h2.display-1,.v-application--wrap h3.display-1{margin-bottom:16px}", ""]);
